<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-library" />
          <h5 class="d-inline ml-2">MenutePay Internal Settlements</h5>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "MenutePayInternalSettlements",
  components: {
    BackendTable,
  },
};
</script>
